import React from 'react';
import { FlameIcon, ShieldIcon, TrophyIcon, StarIcon } from 'lucide-react';
export const CTASection = () => {
  return <div className="bg-yellow-500 py-16" data-id="element-27">
      <div className="container mx-auto px-4 text-center" data-id="element-28">
        <h2 className="text-3xl font-bold mb-8" data-id="element-29">Call to Action</h2>
        <div className="max-w-3xl mx-auto mb-10" data-id="element-30">
          <div className="bg-white text-gray-900 p-6 rounded-lg mb-8" data-id="element-31">
            <p className="text-lg mb-4 flex items-center" data-id="element-32">
              <ShieldIcon className="h-5 w-5 mr-2 text-yellow-600 flex-shrink-0" data-id="element-33" />
              Secure your Legacy #7 Edition today before it's gone forever.
            </p>
            <p className="text-lg mb-4 flex items-center" data-id="element-34">
              <TrophyIcon className="h-5 w-5 mr-2 text-yellow-600 flex-shrink-0" data-id="element-35" />
              Own a piece of Ronaldo's greatness — claim your numbered copy now.
            </p>
            <p className="text-lg flex items-center" data-id="element-36">
              <StarIcon className="h-5 w-5 mr-2 text-yellow-600 flex-shrink-0" data-id="element-37" />
              Be one of the few to preserve the legend.
            </p>
          </div>
          <button onClick={() => {
          document.getElementById('pricing-section')?.scrollIntoView({
            behavior: 'smooth'
          });
        }} className="bg-black text-white py-4 px-10 rounded-md font-bold text-xl hover:bg-gray-800 transition-colors shadow-lg" data-id="element-38">
            SECURE YOUR COPY NOW
          </button>
          <div className="mt-8 flex items-center justify-center text-red-800" data-id="element-39">
            <FlameIcon className="h-6 w-6 mr-2" data-id="element-40" />
            <p className="font-bold whitespace-nowrap" data-id="element-41">
              Once this edition is gone, it's gone. Forever.
            </p>
          </div>
        </div>
      </div>
    </div>;
};